<template>
  <transition name="fade">
    <button v-show="scY > 138" id="pagetop" class="reference-uniform-scroll-top-button" @click="toTop">
      <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.68593 0.292893C5.2954 -0.0976311 4.66224 -0.0976311 4.27171 0.292893L0.292893 4.27191C-0.097631 4.66243 -0.0976311 5.2956 0.292893 5.68612C0.683417 6.07664 1.31658 6.07664 1.70711 5.68612L5.68593 1.70711C6.07645 1.31658 6.07645 0.683417 5.68593 0.292893Z"
          fill="#8E9CBB"
        />
        <path
          d="M4.29628 0.292893C4.6868 -0.0976311 5.31997 -0.0976311 5.71049 0.292893L9.68952 4.27191C10.08 4.66243 10.08 5.2956 9.68952 5.68612C9.299 6.07664 8.66583 6.07664 8.27531 5.68612L4.29628 1.70711C3.90575 1.31658 3.90575 0.683417 4.29628 0.292893Z"
          fill="#8E9CBB"
        />
        <path
          d="M4.97882 0.985811C4.42653 0.985811 3.97882 1.43353 3.97882 1.98581L3.97882 12.0015C3.97882 12.5537 4.42653 13.0015 4.97882 13.0015C5.5311 13.0015 5.97882 12.5537 5.97882 12.0015L5.97882 1.98581C5.97882 1.43353 5.5311 0.985811 4.97882 0.985811Z"
          fill="#8E9CBB"
        />
      </svg>
    </button>
  </transition>
</template>

<script>
export default {
  name: "to-top-button",
  props: {
    element: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      htmlElement: {},
      scY: 0,
    };
  },
  mounted() {
    this.htmlElement = document.querySelector(this.element);
    if (this.htmlElement) {
      this.htmlElement.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    if (this.htmlElement) {
      this.htmlElement.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    toTop() {
      this.htmlElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.scY = this.htmlElement.scrollTop;
    },
  },
};
</script>

<style scoped>
#pagetop {
  position: fixed;
  width: 30px;
  height: 30px;
  box-shadow: 0px 2px 10px rgba(0, 15, 38, 0.25);
  border-radius: 50px;
  background: #ffffff;
  right: 10px;
  bottom: 10px;
  border: none;
  outline: none;
  z-index: 1000;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
